export default __webpack_public_path__ + "static/media/road-works.1db340dc.svg";